import type { ParagraphTealSplitCta as ParagraphTealSplitCtaData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "./ParagraphTealSplitCta.module.css";

/**
 * Layout 53 - `PARAGRAPH_TEAL_SPLIT_CTA_LAYOUT`: teal split CTA.
 *
 * Dark teal full-bleed bg. Lewa kolumna: icon + H2 + opis (HTML) + zielona linia divider.
 * Prawa kolumna: 2 boksy z opcjami (name + desc). Typowo "Dwa modele rozliczenia".
 */
export function ParagraphTealSplitCta({
  paragraph,
  t: _t,
}: {
  paragraph: ParagraphTealSplitCtaData;
  t: ParagraphTranslations;
}) {
  const { icon, name: title, text: desc, items } = paragraph;

  const hasDesc = desc && desc.trim() !== "";

  return (
    <section className={styles.section}>
      <div className={styles.grid}>
        <div className={styles.left}>
          <div className={styles.topRow}>
            {icon ? (
              <i
                className={`${styles.icon} nc-icon-outline ${icon}`}
                aria-hidden="true"
              />
            ) : null}
            {title ? <h2 className={styles.title}>{title}</h2> : null}
          </div>
          {hasDesc ? (
            <div
              className={styles.desc}
              dangerouslySetInnerHTML={{ __html: desc }}
            />
          ) : null}
          <span className={styles.divider} aria-hidden="true" />
        </div>

        {items.length > 0 ? (
          <ul className={styles.boxes}>
            {items.map((item, idx) => (
              <li key={idx} className={styles.box}>
                {item.name ? <h3 className={styles.boxTitle}>{item.name}</h3> : null}
                {item.desc ? <p className={styles.boxDesc}>{item.desc}</p> : null}
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </section>
  );
}
